import React , {useState,useEffect} from 'react'
import Slider from 'react-slick';
import BookItem from '../BookItem/BookItem';
import {setting} from "../../Common/setting"

import { useSelector ,useDispatch} from 'react-redux'
import { fetchBooks } from '../../features/Books/BooksAction';
import './BooksOnSale.css'

const BooksOnSale = () => {

  const [books, setBooks] = useState([]);

  const dispatch = useDispatch();

  const {Books,Books:{categories}} = useSelector((state)=>state)

  // console.log("state in booksonsole",Books);
  // console.log("Categories in booksonsole",categories);

  const fetchAllBooKS = async()=>{
    
    dispatch(fetchBooks(1));

  }
  
  useEffect(() => {
  
      fetchAllBooKS();

      setBooks(Books.books);

  }, [])
  

  return (
    <div className='booksOnSale-container'>

      <h2>Buy Second Hand Books</h2>
      <p>Reading helps you developing your communication skills</p>

      {(books.length <=3)? 
        <div className='row'>
            {
                books.map((element) => {
                
                return (

                <div className='col-lg-3 col-md-3 col-sm-6 col-xs-12' key={element._id}>
                    <BookItem  name={element.title} img={element.images[0]} price={element.fixedPrice} author={element.authors[0]} categories={element.categories} id={element._id} sellerId={element.userId}/>
                </div>
                  
                )})
            }
        </div>:

        <Slider {...setting}>
        {
            books.map((element) => {
                
                return (
                    <BookItem name={element.title} img={element.images[0]} price={element.fixedPrice} author={element.authors[0]} category={element.categories[0]} id={element._id} sellerId={element.userId} key={element._id}/>
            )})
        }
        </Slider>
        }
    </div>
  )
}

export default BooksOnSale